// ABOUTME: Defines applicant schedule action visibility rules for the Agenda tab.
// ABOUTME: Keeps schedule mutations limited to users with candidate or calendar access.
export interface ApplicantSchedulePermissionParams {
    isExternalApplicantView?: boolean;
    userEmail?: string | null;
    hasApplicantListAccess: boolean;
    hasApplicantEditAccess: boolean;
    hasMyCalendarAccess: boolean;
    hasTeamCalendarAccess: boolean;
}

export const canManageApplicantSchedule = ({
    isExternalApplicantView = false,
    userEmail,
    hasApplicantListAccess,
    hasApplicantEditAccess,
    hasMyCalendarAccess,
    hasTeamCalendarAccess
}: ApplicantSchedulePermissionParams) => {
    if (isExternalApplicantView || !userEmail || !hasApplicantListAccess) {
        return false;
    }

    return (
        hasApplicantEditAccess ||
        hasMyCalendarAccess ||
        hasTeamCalendarAccess
    );
};
